import { render, staticRenderFns } from "./submit-button.vue?vue&type=template&id=368c86cd&scoped=true&"
import script from "./submit-button.vue?vue&type=script&lang=js&"
export * from "./submit-button.vue?vue&type=script&lang=js&"
import style0 from "./submit-button.vue?vue&type=style&index=0&id=368c86cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368c86cd",
  null
  
)

export default component.exports